import { MOSAR_URL } from 'app/app-routing.module';
import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { AppStatusService } from "../../../service/app-status/app-status.service";
import { Location } from "@angular/common";
import { ContainerService } from "../container.service";
import { Router, NavigationEnd } from "@angular/router";
import { take } from "rxjs";
import { ConstantsService } from "service/scenariomanager-api/constants.service";
import { SYSTEM_PROOF_URLS } from 'app/system-proof/system-proof-routing.module';

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
  pathItems = [];
  pathItemsLabels = [];
  
  /* Boolean used to display specifics details */

  isSelectedMenuSystemproof= false;
  isSelectedMenuScenario = false;
  isSelectedMenuCollection = false;

  /* Boolean used to display right selected tab */

  isSelectedSubMenuSystems = false;
  isSelectedSubMenuCampaigns = false;
  isSelectedSubMenuTestsProtocol = false;
  isSelectedSubMenuUsecases = false;
  isHomeCampaignPage = false;
  initialPath;

  MOSAR_URL = MOSAR_URL;
  SYSTEMPROOF_URL = '/' + MOSAR_URL.SYSTEM_PROOF;
  CAMPAIGNS_URL = '/' + MOSAR_URL.SYSTEM_PROOF+ '/' + SYSTEM_PROOF_URLS.CAMPAIGNS;
  USECASES_URL = '/' + MOSAR_URL.SYSTEM_PROOF + '/' + SYSTEM_PROOF_URLS.USECASES;
  SYSTEMS_URL = '/' + MOSAR_URL.SYSTEM_PROOF + '/' + SYSTEM_PROOF_URLS.SYSTEMS;
  TESTS_PROTOCOL_URL = '/' + MOSAR_URL.SYSTEM_PROOF + '/' + SYSTEM_PROOF_URLS.TESTS_PROTOCOLS;

  constructor(
    public appStatus: AppStatusService,
    private location: Location,
    private containerService: ContainerService,
    private constantService: ConstantsService,
    private router: Router,
    private changeDedectionRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // Reaction to routing events: update sections and breadcrumb display
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.updateCurrentSelectedSection(this.location.path());
        this.pathItems = this.getPathItems(this.location.path());
        this.initInitialPath();
        for (
          let itemIndex = 0;
          itemIndex < this.pathItems.length;
          itemIndex++
        ) {
          this.updatePathItemLabelAsync(
            this.pathItems[itemIndex].label,
            itemIndex
          );
        }
      }
    });
  }

  private initInitialPath() {
    if(this.isSelectedMenuScenario) {
      this.initialPath = `${MOSAR_URL.SCENARIO_MANAGER}`;
    } else if(this.isSelectedMenuSystemproof) {
      this.initialPath = `${MOSAR_URL.SYSTEM_PROOF}`
    } else if (this.isSelectedMenuCollection) {
      this.initialPath = `${MOSAR_URL.FRAME_OF_REFERENCE}`
    }
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }

  /**
   * Construct the path tree from the current location
   */
  private getPathItems(locationPath: string) {
    let pathStack = locationPath.split("?")[0].split("/");
    pathStack = pathStack.filter((p) => p != "");
    pathStack.shift();
    let initialPath = "";
    if(this.isSelectedMenuScenario) {
      initialPath = `/${MOSAR_URL.SCENARIO_MANAGER}/`;
    } else if(this.isSelectedMenuSystemproof) {
      initialPath = `/${MOSAR_URL.SYSTEM_PROOF}/`;
    } else if (this.isSelectedMenuCollection) {
      initialPath = `/${MOSAR_URL.FRAME_OF_REFERENCE}/`;
    }
    return pathStack.map((pathItem, itemIndex) => {
      let label = '';
      switch(pathItem) {
        case 'list':
          label = 'Containers';
          break;
        case 'usecases':
          label = 'Use Cases';
          break;
        case 'drivingautomationsystems':
          label = 'Driving Automation Systems';
          break;
        case 'testprotocols':
          label = 'Test Protocols';
          break;
        default:
          label = pathItem;
          break;
      }
      return {
        route: initialPath + pathStack.slice(0, itemIndex + 1).join("/"),
        label: label,
      };
    });
  }

  /**
   * Update flags indicating which section is currently selected
   * @param currentPath Current routing path
   */
  private updateCurrentSelectedSection(currentPath: string) {
    this.isSelectedMenuScenario = false;
    this.isSelectedMenuSystemproof = false;
    this.isSelectedMenuCollection = false;
    if (currentPath.includes(MOSAR_URL.SCENARIO_MANAGER)) {
      this.isSelectedMenuScenario = true;
    } else if (currentPath.includes(MOSAR_URL.SYSTEM_PROOF)) {
      this.isSelectedMenuSystemproof = true;
    } else if (currentPath.includes(MOSAR_URL.FRAME_OF_REFERENCE)) {
      this.isSelectedMenuCollection = true;
    }

    /* Tabs part */

    this.isSelectedSubMenuSystems = false;
    this.isSelectedSubMenuCampaigns = false;
    this.isSelectedSubMenuTestsProtocol = false;
    this.isSelectedSubMenuUsecases = false;
    this.isHomeCampaignPage = false;

    if (currentPath.includes(SYSTEM_PROOF_URLS.CAMPAIGNS)) {
      this.isSelectedSubMenuCampaigns = true;
    } else if (currentPath.includes(SYSTEM_PROOF_URLS.SYSTEMS)) {
      this.isSelectedSubMenuSystems = true;
    } else if (currentPath.includes(SYSTEM_PROOF_URLS.TESTS_PROTOCOLS)) {
      this.isSelectedSubMenuTestsProtocol = true;
    } else if (currentPath.includes(SYSTEM_PROOF_URLS.USECASES)) {
      this.isSelectedSubMenuUsecases = true;
    } else {
      this.isHomeCampaignPage = true;
    }
  }

  /**
   * Change the label of some path items to be more human relevant
   * @param itemValue
   * @param pathItemIndex
   */
  private updatePathItemLabelAsync(itemValue, pathItemIndex) {
    // Change the label of path items that are a resource identifier by the name of the referenced resource
    const previousItemLabel = this.pathItems[pathItemIndex - 1]
      ? this.pathItems[pathItemIndex - 1].label
      : null;
      const previouPrevioussItemLabel = this.pathItems[pathItemIndex - 2]
      ? this.pathItems[pathItemIndex - 2].label
      : null;
    let collectionName = null;
    if(this.isSelectedMenuScenario) {
      collectionName = "scenario";
    } else if(this.isSelectedMenuSystemproof) {
      switch(previouPrevioussItemLabel) {
        case 'campaigns':
          collectionName = 'campaign';
          break;
        case 'Use Cases':
          collectionName = 'usecase';
          break;
        case 'Driving Automation Systems':
          collectionName = 'drivingautomationsystem';
          break;
        case 'Test Protocols':
          collectionName = 'testprotocol';
          break;
        default:
          collectionName = null;
      }
    } else if (this.isSelectedMenuCollection) {
      collectionName = previousItemLabel;
    }
    if (
      ((previousItemLabel &&  previousItemLabel === 'Containers') 
      || this.isSelectedMenuCollection)   && 
      this.constantService
        .getCollectionsAndLibrariesInfo()
        .map((lib) => lib.nameApi)
        .includes(collectionName)
    ) {
      const container = this.containerService.getLocalContainerById(
        collectionName,
        itemValue
      );
      if (container) {
        this.pathItemsLabels[pathItemIndex] = container.resources[0].name;
      } else if (typeof itemValue === "string" && itemValue !== "search") {
        this.containerService
          .getContainerById(collectionName, itemValue)
          .pipe(take(1))
          .subscribe((resp) => {
            this.pathItemsLabels[pathItemIndex] = resp.resources[0].name;
          });
      } else if (itemValue === "search") {
        this.pathItemsLabels[pathItemIndex] = "search";
      }
    } else {
      this.pathItemsLabels[pathItemIndex] = itemValue;
    }

    this.applyLabelWorkarounds(pathItemIndex);
  }

  private applyLabelWorkarounds(pathItemIndex) {
    const collection = this.constantService
      .getCollectionsAndLibrariesInfo()
      .find(
        (collection) =>
          collection.nameApi === this.pathItemsLabels[pathItemIndex]
      );
    if (collection) {
      this.pathItemsLabels[pathItemIndex] = collection.label;
    }

    // Suffix upper level of sections with "containers"
    if (
      this.pathItemsLabels[pathItemIndex] == "driving automation system" ||
      this.pathItemsLabels[pathItemIndex] == "usecase" ||
      this.pathItemsLabels[pathItemIndex] == "testprotocol" ||
      this.pathItemsLabels[pathItemIndex] == "scenarios"
    ) {
      this.pathItemsLabels[pathItemIndex] += " containers";
    }
  }
}
